import { Card, Text, Title } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Page } from '@flecto/ui/saas'

import { CardInsuranceTerms } from '../components/CardInsuranceTerms/CardInsuranceTerms'

export function PageInsurancesSettings() {
  const { t } = useTranslation('saas', { keyPrefix: 'insurances' })

  return (
    <Page>
      <Page.Title>{t('title')}</Page.Title>
      <Page.Content>
        <Card withBorder>
          <Title order={5}>{t('card_title')}</Title>
          <Text c='gray.7'>{t('card_description')}</Text>
        </Card>
        <CardInsuranceTerms />
      </Page.Content>
    </Page>
  )
}
